import http from "../../../../../core/utils/apis/api";

const getCoursesData = async (options) => {
    try {
        const response = await http({
            method: 'GET',
            url: '/courses',
            params: options,

        });
        return response;
    } catch (e) {
        throw e;
    }

}

// service for delete course
const deleteCourse = async (id) => {
    try {
        const response = await http({
            method: 'DELETE',
            url: `/courses/${id}`
        });
        return response;
    } catch (e) {
        throw e;
    }
}

const coursesService = {
    getCoursesData,
    deleteCourse
};

export default coursesService;
